import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { AcademicsRoutingModule } from './academics-routing.module';
import { AcademicsListComponent } from './academics-list/academics-list.component';
import { AcademicsCreateComponent } from './academics-create/academics-create.component';

@NgModule({
  declarations: [AcademicsListComponent, AcademicsCreateComponent],
  imports: [
    CommonModule,
    AcademicsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class AcademicsModule { }
